import React from 'react'
import Glyphicon from 'react-bootstrap/lib/Glyphicon'

const NewWindowIcon = () => (
  <Glyphicon glyph="new-window" style={{fontSize: 11, marginLeft: 5}} />
)

export default NewWindowIcon



// WEBPACK FOOTER //
// ./src/components/shared/NewWindowIcon.js